<template>
  <div class="question-container">
    <!-- PREVIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
        </div>

        <div class="col-md-7">
          <template v-if="answer && answer.answerText">
            <div>{{ answer[JsonFieldToDisplay()] }}</div>
          </template>
        </div>
        <template v-if="answer && answer.answerText">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <span class="index-no" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
          <template v-if="activityType == 'activity'">
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-html="question.formattedBody"></span>
          </template>
          <template v-else>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
            <span class="question-text" :class="isQuestionSkipped() ? 'disable-question' : ''" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
          </template>
          <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="question.isSkippable">Optional</span>
          <span v-if="isQuestionSkipped()" class="skipped-question-box ml-15 d-inline-box pt-2">
            Skipped
          </span>
        </div>
        <div class="col-md-7" :class="isQuestionSkipped() ? 'disable-question' : ''">
          <div v-if="question.direction.toLowerCase() === 'horizontal'">
            <div v-if="surveyData && surveyData.newLayout == true">
              <div class="row">
                <div class="pl-0 pr-7 col-md-2">
                  {{ question.minValueLabel }}
                </div>
                <ds-slider
                  data-testid="number-scale-horizontal-slider"
                  :ref="`slider-${question.id}`"
                  :value="answer && answer.answerText"
                  :name="`ds-slider-select-${question.id}`"
                  :piecewise="true"
                  direction="horizontal"
                  class="horizontal-vue-slider pt-30 col-md-8"
                  :class="{ 'box-slider': !!question.numericRatingScale }"
                  :min="question.minValue"
                  :max="question.maxValue"
                  :disabled="answer && answer.isDisabled ? true : false"
                  :piecewiseLabel="true"
                  :dotSize="answer.isSkipped ? 0 : 10"
                  :tooltip="answer.isSkipped ? false : 'always'"
                  :clickable="false"
                  @drag-start="refreshScale(question.id)"
                  :interval="question.partitions"
                  @input="onSliderValueChange($event)"
                  @drag-end="onSliderValueChange"
                  :isNumericRatingScale="!!question.numericRatingScale"
                >
                </ds-slider>
                <div class="pr-0 col-md-2">
                  {{ question.minValueLabel }}
                </div>
              </div>
            </div>
            <div v-else>
              <ds-slider
                :ref="`slider-${question.id}`"
                :value="answer && answer.answerText"
                :name="`ds-slider-select-${question.id}`"
                :piecewise="true"
                direction="horizontal"
                class="horizontal-vue-slider pt-20"
                :class="{ 'box-slider': !!question.numericRatingScale }"
                :min="question.minValue"
                :max="question.maxValue"
                :disabled="answer && answer.isDisabled ? true : false"
                :piecewiseLabel="true"
                :dotSize="answer.isSkipped ? 0 : 10"
                :tooltip="answer.isSkipped ? false : 'always'"
                :clickable="false"
                @drag-start="refreshScale(question.id)"
                :interval="question.partitions"
                @input="onSliderValueChange($event)"
                @drag-end="onSliderValueChange"
                :isNumericRatingScale="!!question.numericRatingScale"
              >
              </ds-slider>
            </div>
          </div>

          <div v-else-if="question.direction.toLowerCase() === 'vertical'">
            <ds-slider
              :ref="`slider-${question.id}`"
              :value="answer && answer.answerText"
              :name="`ds-slider-select-${question.id}`"
              :piecewise="true"
              direction="vertical"
              :min="question.minValue"
              :max="question.maxValue"
              :disabled="answer && answer.isDisabled ? true : false"
              :height="300"
              :piecewiseLabel="true"
              :width="5"
              class="vertical-vue-slider"
              :dotSize="answer.isSkipped ? 0 : 10"
              :tooltip="answer.isSkipped ? false : 'always'"
              :clickable="false"
              :interval="question.partitions"
              @drag-start="refreshScale(question.id)"
              @input="onSliderValueChange($event)"
              @drag-end="onSliderValueChange"
              :isNumericRatingScale="!!question.numericRatingScale"
            >
            </ds-slider>
          </div>

          <span v-if="hasFieldError" class="text-danger">
            <p>{{ fieldErrorText }}</p>
          </span>
          <span v-if="hasFieldWarning" class="text-warning pl-5 fw-bold pt-10">
            {{ fieldWarningText }}
          </span>
        </div>
        <template v-if="answer && answer.answerText && !answer.isSkipped">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity' && answer.score != null">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ answer.score }}
            </div>
          </div>
        </template>
        <template v-else-if="question.isSkippable">
          <div class="ml-25 d-inline-block pt-20" :class="isQuestionSkipped() ? 'disable-question' : ''" v-if="showScore && activityType == 'activity'">
            <label class="fs-12">Score</label>
            <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
              {{ question.skipScore || 0 }}
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- RESPONSE MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-5 d-flex pl-0">
          <div class="row">
            <div class="col-md-12 d-flex p-0 answers">
              <span class="changed" v-if="answer && answer.edit_status == 1"></span>
              <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>
              <template v-if="activityType == 'activity'">
                <span class="question-text" v-html="question.formattedBody"></span>
              </template>
              <template v-else>
                <span class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></span>
                <span class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></span>
              </template>
              <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" v-if="question.isSkippable">Optional</span>
            </div>
            <!-- CURRENT ANSWER -->
            <template v-if="answer && answer.answer_text">
              <div class="col-md-12 d-flex pl-30">
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.answer_text : answer.display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-25 pt-10" v-if="showScore && activityType == 'activity' && answer.score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="col-md-7 previous-answer" v-if="answer && answer.edit_status == 1">
          <div>
            <span class="previous-value-mark"></span>
            <div class="previous-value ml-3">PREVIOUS RESPONSE</div>

            <template v-if="answer && answer.privius_answer_text">
              <div>
                <span class="text-align">{{ selectedLanguageCulture == "EN" ? answer.privius_answer_text : answer.privius_display_answer_text }}</span>
              </div>
              <div class="row">
                <div class="d-inline-block ml-0 pt-10" v-if="showScore && answer.privius_score != null">
                  <label>Score</label>
                  <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                    {{ answer.privius_score }}
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="question.isSkippable">
              <div class="ml-25 d-inline-block pt-20" v-if="showScore && activityType == 'activity'">
                <label class="fs-12">Score</label>
                <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                  {{ question.skipScore || 0 }}
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
import dsSlider from "../../../../lib/ds-slider-component";

export default {
  name: "NumberScaleResponse",
  mixins: [activityCommonMixin],
  data() {
    return {
      updatedAns: this.answer && this.answer.answerText,
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: ""
    };
  },
  components: {
    dsSlider
  },
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    usage: Object,
    surveyData: Object,
    stepIndex: Number,
    selectedLanguageCulture: String,
    activityType: String
  },
  watch: {
    hasFieldError(val) {
      this.question.hasFieldError = val;
    },
    fieldErrorText(val) {
      this.question.fieldErrorText = val;
    }
  },
  methods: {
    isSkippable(question) {
      return question.isSkipped || question.isSkippable;
    },
    onSliderValueChange(value) {
      if (this.isQuestionSkipped()) {
        return;
      }
      if (typeof value === "object") {
        this.updatedAns = `${value.val}`;
      } else {
        this.updatedAns = `${value}`;
      }

      this.checkForFieldErrors();

      if (this.answer && !this.hasFieldError) {
        this.$set(this.answer, "score", this.updatedAns);
        this.$set(this.answer, "computedScore", this.updatedAns);
      }

      this.$emit(`answerChanged`, {
        questionId: this.question.id,
        newAns: this.updatedAns
      });
    },
    refreshScale(questionId) {
      const ref = `slider-${questionId}`;
      this.$nextTick(() => {
        this.$refs[ref].refresh();
      });
    },
    checkForFieldErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";

      this.question.dataChecks = [];

      if (this.question.dataEditChecks) {
        let softDataCheck = false;
        for (let k = 0; k < this.question.dataEditChecks.length; k++) {
          if (this.question.dataEditChecks[k].check == "SOFT") {
            if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.updatedAns) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is greater than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.updatedAns) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is less than the expected range ${this.question.dataEditChecks[k].value}. Please review your response.`;
              this.question.dataChecks.push({
                dataCheckId: this.question.dataEditChecks[k].id,
                dataCheckType: this.question.dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
          } else {
            if (this.question.dataEditChecks[k].type == "GREATER_THAN" && this.question.dataEditChecks[k].value > this.updatedAns) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              this.fieldErrorText = `Please enter a response less than ${this.question.dataEditChecks[k].value}.`;

              this.question.isSkippable = false;
            } else if (this.question.dataEditChecks[k].type == "LESS_THAN" && this.question.dataEditChecks[k].value < this.updatedAns) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              this.fieldErrorText = `Please enter a response greater than ${this.question.dataEditChecks[k].value}.`;

              this.question.isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      } else {
        if (!this.question.isSkippable && !!this.updatedAns == false) {
          this.hasFieldError = true;
          this.fieldErrorText = "This field is required.";
        }
      }
    },
    isQuestionSkipped() {
      return this.answer.isSkipped;
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: -29px;
  top: 0;
  width: 18px;
  height: 51px;
  border-radius: 1px;
  background-color: #f5a623;
}

.question-text {
  display: inline;
}

.previous-value-mark {
  width: 9px;
  height: 51px;
  background-color: #f5a623;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.previous-value {
  /* font-family: Roboto; */
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #f5a623;
  margin-bottom: 9px;
  margin-top: 3px;
}

.answers {
  font-weight: 600;
  color: #000000;
}
</style>

<style>
.box-slider .vue-box-select li {
  margin: 0 1% !important;
}
</style>
